import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["segment"]

  connect() {
    this.activeSegmentIndex = -1
    this.mediaElement = this.findMediaElement()
    this.buildSegmentTimes()
    this.setupMediaEvents()
    this.highlightActiveSegment(this.currentSecond)
  }

  disconnect() {
    this.teardownMediaEvents()
    this.clearActiveSegment()
  }

  findMediaElement() {
    return this.element.querySelector('[data-media-player-target="media"]') || this.element.querySelector("audio")
  }

  setupMediaEvents() {
    if (!this.mediaElement) return

    this.boundTimeUpdate = this.handlePlaybackPositionChange.bind(this)
    this.boundSeeked = this.handlePlaybackPositionChange.bind(this)
    this.boundMetadataLoaded = this.handlePlaybackPositionChange.bind(this)
    this.boundEnded = this.handleEnded.bind(this)

    this.mediaElement.addEventListener("timeupdate", this.boundTimeUpdate)
    this.mediaElement.addEventListener("seeked", this.boundSeeked)
    this.mediaElement.addEventListener("loadedmetadata", this.boundMetadataLoaded)
    this.mediaElement.addEventListener("ended", this.boundEnded)
  }

  teardownMediaEvents() {
    if (!this.mediaElement) return

    this.mediaElement.removeEventListener("timeupdate", this.boundTimeUpdate)
    this.mediaElement.removeEventListener("seeked", this.boundSeeked)
    this.mediaElement.removeEventListener("loadedmetadata", this.boundMetadataLoaded)
    this.mediaElement.removeEventListener("ended", this.boundEnded)
  }

  buildSegmentTimes() {
    if (!this.hasSegmentTarget) {
      this.segmentStarts = []
      return
    }

    this.segmentStarts = this.segmentTargets.map((segment) => {
      const startSecond = Number.parseFloat(segment.dataset.startSecond)
      return Number.isFinite(startSecond) ? startSecond : 0
    })
  }

  seekTo(event) {
    if (!this.mediaElement) return

    const segment = event.currentTarget
    const startSecond = Number.parseFloat(segment.dataset.startSecond)
    if (!Number.isFinite(startSecond)) return

    this.mediaElement.currentTime = startSecond
    this.highlightActiveSegment(startSecond)

    const playPromise = this.mediaElement.play()
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {})
    }
  }

  handlePlaybackPositionChange() {
    this.highlightActiveSegment(this.currentSecond)
  }

  handleEnded() {
    this.clearActiveSegment()
  }

  get currentSecond() {
    if (!this.mediaElement) return 0

    const second = this.mediaElement.currentTime
    return Number.isFinite(second) ? second : 0
  }

  highlightActiveSegment(currentTime) {
    if (!this.segmentStarts || this.segmentStarts.length === 0) {
      this.clearActiveSegment()
      return
    }

    let activeIndex = -1
    for (let i = this.segmentStarts.length - 1; i >= 0; i--) {
      if (currentTime >= this.segmentStarts[i]) {
        activeIndex = i
        break
      }
    }

    if (activeIndex === this.activeSegmentIndex) return
    this.activeSegmentIndex = activeIndex

    this.segmentTargets.forEach((el, i) => {
      el.classList.toggle("active", i === activeIndex)
    })
  }

  clearActiveSegment() {
    this.activeSegmentIndex = -1
    this.segmentTargets.forEach((el) => el.classList.remove("active"))
  }
}
